import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MEDIA } from "@/data/media";

export const Hero = () => (
  <section
    className="relative overflow-hidden bg-[#1a1512] lg:bg-transparent"
    data-testid="hero-section"
  >
    {/* Desktop cream background */}
    <div
      className="hidden lg:block absolute inset-0"
      style={{ background: "linear-gradient(105deg, #EFE7D8 0%, #EAE0CE 45%, #E4D6BE 100%)" }}
    />
    {/* Mobile full-bleed image background */}
    <div className="lg:hidden absolute inset-0">
      <img
        src={MEDIA.hero}
        alt="South Asian bridal jewellery - Zebaa Green Street, London"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-black/45" />
    </div>

    <div className="relative max-w-[1800px] mx-auto px-5 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center min-h-[600px] sm:min-h-[640px] lg:min-h-[560px]">
        <div className="py-16 lg:py-0 lg:pr-10 z-10">
          <p className="text-xs uppercase tracking-[0.28em] font-semibold text-white/75 lg:text-charcoal/60 animate-fade-up">
            New Collection Now Live
          </p>
          <h2
            className="font-sans font-semibold tracking-tight text-5xl sm:text-6xl lg:text-[4.75rem] leading-[1.03] mt-4 text-white lg:text-charcoal animate-fade-up"
            style={{ animationDelay: "0.1s" }}
          >
            Find Your<br />
            <span className="text-pink">
              Perfect Piece
            </span>
          </h2>
          <p
            className="text-base sm:text-lg text-white/80 lg:text-charcoal/70 mt-5 max-w-md animate-fade-up"
            style={{ animationDelay: "0.25s" }}
          >
            Bridal sets, kundan-style necklaces and gold-tone bangles - for weddings, celebrations and everything in between.
          </p>
          <Link
            to="/shop/new-in"
            data-testid="hero-cta"
            className="inline-flex items-center gap-3 mt-8 bg-pink text-white px-9 py-4 text-xs uppercase tracking-[0.18em] font-semibold rounded-full hover:bg-pink-hover transition-colors duration-300 animate-fade-up"
            style={{ animationDelay: "0.35s" }}
          >
            Shop Collection <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>

    {/* Desktop right image */}
    <div className="hidden lg:block lg:absolute lg:top-0 lg:right-0 lg:h-full lg:w-[52%]">
      <img
        src={MEDIA.hero}
        alt="South Asian bridal jewellery - Zebaa Green Street, London"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-[#EAE0CE] to-transparent" />
    </div>
  </section>
);
